import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { ClerkProvider } from '@clerk/clerk-react'
import { trTR } from '@clerk/localizations'
import './index.css'
import App from './App.tsx'
import { applyAccessibilitySettings, getAccessibilitySettings } from './utils/accessibility';

// Erişilebilirlik ayarlarını uygulama başlangıcında yükle (tüm sayfalar için)
applyAccessibilitySettings(getAccessibilitySettings());

registerSW({ immediate: false })

if ('serviceWorker' in navigator) {
  // sessionStorage kullanıyoruz çünkü reload sonrası JS değişkenleri sıfırlanır —
  // autoUpdate modunda yeni SW her aktive olduğunda controllerchange tekrar tetiklenip
  // sonsuz reload döngüsüne girebiliyordu. Bayrak, oturum başına tek reload'a sınırlıyor.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!sessionStorage.getItem('sw_reload_done')) {
      sessionStorage.setItem('sw_reload_done', 'true');
      window.location.reload();
    }
  });
}
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.warn("Missing Publishable Key for Clerk");
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {PUBLISHABLE_KEY ? (
      <ClerkProvider 
        localization={trTR}
        publishableKey={PUBLISHABLE_KEY} 
        afterSignOutUrl="/"
        appearance={{
          variables: {
            colorPrimary: '#3b82f6', // blue-500
            colorText: '#0f172a',
            colorBackground: '#ffffff',
            colorInputBackground: '#f8fafc',
            colorInputText: '#0f172a',
            borderRadius: '1rem',
            fontFamily: 'system-ui, sans-serif'
          },
          layout: {
            socialButtonsPlacement: 'bottom',
            socialButtonsVariant: 'auto',
          },
          elements: {
            card: "shadow-2xl rounded-3xl border border-slate-100",
            formButtonPrimary: "font-bold shadow-md",
            socialButtonsBlockButton: "border border-slate-200 hover:bg-slate-50 transition-colors",
            dividerLine: "bg-slate-200",
            dividerText: "text-slate-400 font-medium",
            formFieldInput: "border-slate-200 focus:border-blue-500 rounded-xl",
            footerActionLink: "text-accent-500 hover:text-accent-600 font-bold",
            headerTitle: "font-black text-slate-900",
            headerSubtitle: "text-slate-500"
          }
        }}
      >
        <App />
      </ClerkProvider>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', backgroundColor: '#f8fafc', color: '#0f172a', padding: '20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', color: '#dc2626' }}>⚠️ Sistem Yapılandırması Eksik</h2>
        <p style={{ marginBottom: '12px' }}><strong>VITE_CLERK_PUBLISHABLE_KEY</strong> çevre değişkeni bulunamadı.</p>
        <p style={{ maxWidth: '600px', lineHeight: '1.5', color: '#475569' }}>Eğer uygulamayı Cloudflare Pages veya Vercel'e deploy ettiyseniz, lütfen proje ayarlarından <strong>Environment Variables (Çevre Değişkenleri)</strong> kısmına bu anahtarı ekleyip projenizi yeniden derleyin (redeploy).</p>
      </div>
    )}
  </StrictMode>,
)
